// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PartenairesRouteImport } from './routes/partenaires'
import { Route as MethodologieRouteImport } from './routes/methodologie'
import { Route as MentionsLegalesRouteImport } from './routes/mentions-legales'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ConfidentialiteRouteImport } from './routes/confidentialite'
import { Route as ComparateurMicroBicReelRouteImport } from './routes/comparateur-micro-bic-reel'
import { Route as IndexRouteImport } from './routes/index'

const PartenairesRoute = PartenairesRouteImport.update({
            id: '/partenaires',path: '/partenaires',getParentRoute: () => rootRouteImport
          })
const MethodologieRoute = MethodologieRouteImport.update({
            id: '/methodologie',path: '/methodologie',getParentRoute: () => rootRouteImport
          })
const MentionsLegalesRoute = MentionsLegalesRouteImport.update({
            id: '/mentions-legales',path: '/mentions-legales',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ConfidentialiteRoute = ConfidentialiteRouteImport.update({
            id: '/confidentialite',path: '/confidentialite',getParentRoute: () => rootRouteImport
          })
const ComparateurMicroBicReelRoute = ComparateurMicroBicReelRouteImport.update({
            id: '/comparateur-micro-bic-reel',path: '/comparateur-micro-bic-reel',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ComparateurMicroBicReelRoute: ComparateurMicroBicReelRoute,ConfidentialiteRoute: ConfidentialiteRoute,FaqRoute: FaqRoute,MentionsLegalesRoute: MentionsLegalesRoute,MethodologieRoute: MethodologieRoute,PartenairesRoute: PartenairesRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)